import { useNavigate } from 'react-router-dom'
import { TrialSuccess } from '../../Common/TrialSuccess'

export const OAuth2AppDirectorySuccess: React.FC = () => {
  const navigate = useNavigate()

  return <TrialSuccess buttonLabel='Go to Apps' onButtonClick={() => navigate('/account/integration-settings/oauth2apps')} />
}
